import { compose } from 'recompose'
import { connect } from 'react-redux'
import toggle from 'components/common/hoc/toggle'
import { formatPhoneNumber } from 'helpers/phone-number'
import { showStoreLocatorModalInAppointmentMode } from 'actions/storeLocator'
import ServiceBlock from './ServiceBlock'

const mapStateToProps = ({ myStore }) => ({
  myStore,
  storePhoneNumber: myStore ? myStore.phoneNumbers[0] : undefined,
  formattedStorePhoneNumber: myStore ? formatPhoneNumber(myStore.phoneNumbers[0]) : undefined
})

export default compose(
  connect(mapStateToProps, { showStoreLocatorModalInAppointmentMode }),
  toggle
)(ServiceBlock)
